import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IResponse } from '../interfaces/response';
import { Login } from '../interfaces/login';
import { User } from '../class/User';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly http = inject(HttpClient);

  private isUserLogged = false;
  private readonly apiAuthUrl = '/login';
  private readonly apiNewPassword = '/cambiaPassword';
  private readonly apiSendPassword = '/sendNewPassword';
  private readonly apiUrlLogout = '/logout';
  private readonly apiUrlRegistrazione = '/saveUser';
  private readonly apiUrlConfermaRegistrazione = '/validaRegistrazione';
  private readonly apiUrlRecuperaPassword = '/recuperaPassword';
  private readonly apiCheckTokenNewPassword = '/checkToken';
  private readonly apiCreateTokenMS = '/createTokenMS';
  private readonly apiUrl = environment.apiUrl; // Base URL for the API

  private token!: string;
  public login!: Login;

  isUserLoggedIn(): boolean {
    const loginData = JSON.parse(localStorage['loginData'] || '{}');
    const token = loginData !== null && 'items' in loginData ? loginData.items.token : null;
    this.isUserLogged = token !== null && token !== '' && token !== 'null';
    return this.isUserLogged;
  }

  getTypeUser(): any {
    const loginData = JSON.parse(localStorage['loginData'] || '{}');
    const typeUser = loginData !== null && 'items' in loginData ? loginData.items.tipoUser : null;
    return typeUser || '';
  }

  getIdUser(): string {
    const loginData = JSON.parse(localStorage['loginData'] || '{}');
    const idUtente = loginData.items.idUtente;
    return idUtente || '';
  }

  getName(): string {
    const loginData = JSON.parse(localStorage['loginData'] || '{}');
    return 'items' in loginData ? loginData.items.nome : null;
  }

  getSurname(): string {
    const loginData = JSON.parse(localStorage['loginData'] || '{}');
    return 'items' in loginData ? loginData.items.cognome : null;
  }

  getNewPassword(token: string, newPassword: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers };
    const params = new URLSearchParams();
    params.set('newPassword', newPassword);
    params.set('token', token);
    const body = params.toString();
    return this.http.post(this.apiUrl + this.apiNewPassword, body, options).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  checkTokenNewPassword(token: string) {
    const params = { params: { token: token } };
    return this.http.get(this.apiUrl + this.apiCheckTokenNewPassword, params).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  sendPassword(email: string, token: string) {
    return this.http
      .post(this.apiUrl + this.apiSendPassword, {
        email: email,
        token: token,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        })
      );
  }

  logIn(email: string, password: string, keepConn: string): Observable<Login> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers };
    const params = new URLSearchParams();
    params.set('email', email);
    params.set('password', password);
    params.set('keepConn', keepConn);

    const body = params.toString();

    return this.http.post(this.apiUrl + this.apiAuthUrl, body, options).pipe(
      map((l: any) => {
        const loginData: Login = l;
        if (loginData.status === 'OK') {
          localStorage.clear();
          localStorage.setItem('loginData', JSON.stringify(loginData));
          // Is it useful?
          // const user = new User();
          // user.email = loginData.items.email;
          // user.userName = loginData.items.userName;
        }
        return loginData;
      })
    );
  }

  createTokenMS(user: { account: { username: string }; accessToken: string }): Observable<Login> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers };
    const params = new URLSearchParams();
    params.set('email', user.account.username);
    params.set('tokenMS', user.accessToken);

    const body = params.toString();

    return this.http.post(this.apiUrl + this.apiCreateTokenMS, body, options).pipe(
      map((l: any) => {
        const loginData: Login = l;
        if (loginData.status === 'OK') {
          localStorage.clear();
          localStorage.setItem('loginData', JSON.stringify(loginData));
        }
        return loginData;
      })
    );
  }

  registrati(
    email: string,
    username: string,
    nome: string,
    cognome: string,
    password: string,
    dataNascita: any,
    gender: string,
    consensoPub: string,
    consensoTermini: string
  ) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers };
    const params = new URLSearchParams();
    params.set('email', email);
    params.set('userName', username);
    params.set('password', password);
    params.set('nome', nome);
    params.set('cognome', cognome);
    const dateFormatted = dataNascita['year'] + '-' + dataNascita['month'] + '-' + dataNascita['day'];
    params.set('dataNascita', dateFormatted);
    params.set('gender', gender);
    params.set('consensoPub', consensoPub);
    params.set('consensoTermini', consensoTermini);
    params.set('sendEmail', 'true');

    const body = params.toString();

    return this.http.post(this.apiUrl + this.apiUrlRegistrazione, body, options).pipe(
      map((l: any) => {
        const loginData: Login = l;
        if (loginData.status === 'OK') {
          console.log(JSON.stringify(loginData));
          localStorage.setItem('loginData', JSON.stringify(loginData));
        }
        return loginData;
      })
    );
  }

  logout() {
    this.token = this.getToken();
    this.setToken(null);
    const contentType = 'application/x-www-form-urlencoded';

    const headers = new HttpHeaders({ 'Content-Type': contentType, token: this.token });
    const options = { headers };

    const params = new URLSearchParams();
    params.set('token', this.token);
    const body = params.toString();

    return this.http.post(this.apiUrl + this.apiUrlLogout, body, options).pipe(
      map((l: any) => {
        const loginData: Login = l;
        this.isUserLogged = false;
        localStorage.clear();
        return loginData;
      })
    );
  }

  getUser(): User {
    let ret = new User();
    if (localStorage['loginData']) {
      const loginData = JSON.parse(localStorage['loginData']);
      const userData = loginData.userData;
      if (userData) {
        const user = new User();
        user.nome = loginData.userData.nome;
        user.cognome = loginData.userData.cognome;
        user.email = loginData.userData.email;
        user.id = loginData.userData.id;
        user.typeUser = loginData.userData.typeUser;
        user.cell = loginData.userData.cell;
        ret = user;
      }
    }
    return ret;
  }

  getToken(): any {
    let loginData = null;
    if (localStorage.getItem('loginData') !== null) {
      loginData = JSON.parse(localStorage['loginData']);
    } else {
      return null;
    }
    let token = null;
    if (loginData !== null) {
      token = loginData?.items?.token ?? null;
    }
    return token;
  }

  setToken(param: null): void {
    let loginData = null;
    if (localStorage.getItem('loginData') !== null) {
      loginData = JSON.parse(localStorage['loginData']);
    }
    loginData.items.token = param;
    localStorage.setItem('loginData', JSON.stringify(loginData));
  }

  disableFirstLogin() {
    const loginData = JSON.parse(localStorage['loginData']);
    loginData.userData.isFirstLogin = false;
    localStorage.setItem('loginData', JSON.stringify(loginData));
  }

  confermaRegistrazione(tokenReg: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers };
    const params = new URLSearchParams();
    params.set('tokenReg', tokenReg);
    const body = params.toString();
    return this.http.post(this.apiUrl + this.apiUrlConfermaRegistrazione, body, options).pipe(
      map((r: any) => {
        const resp: IResponse = r;
        return resp;
      })
    );
  }

  getLikNewPassword(email: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers };
    const params = new URLSearchParams();
    params.set('email', email);
    const body = params.toString();
    return this.http.post(this.apiUrl + this.apiUrlRecuperaPassword, body, options).pipe(
      map((r: any) => {
        const resp: IResponse = r;
        return resp;
      })
    );
  }

  setNome(param: any) {
    let loginData = null;
    if (localStorage.getItem('loginData') !== null) {
      loginData = JSON.parse(localStorage['loginData']);
    }
    loginData.items.nome = param;
    localStorage.setItem('loginData', JSON.stringify(loginData));
  }

  setSurname(param: any) {
    let loginData = null;
    if (localStorage.getItem('loginData') !== null) {
      loginData = JSON.parse(localStorage['loginData']);
    }
    loginData.items.cognome = param;
    localStorage.setItem('loginData', JSON.stringify(loginData));
  }

  setGender(param: any) {
    let loginData = null;
    if (localStorage.getItem('loginData') !== null) {
      loginData = JSON.parse(localStorage['loginData']);
    }
    loginData.items.gender = param;
    localStorage.setItem('loginData', JSON.stringify(loginData));
  }

  setDataNascita(param: any) {
    let loginData = null;
    if (localStorage.getItem('loginData') !== null) {
      loginData = JSON.parse(localStorage['loginData']);
    }
    loginData.items.dataNascita = param;
    localStorage.setItem('loginData', JSON.stringify(loginData));
  }

  getProfile(): any {
    let loginData = null;
    if (localStorage.getItem('loginData') !== null) {
      loginData = JSON.parse(localStorage['loginData']);
    } else {
      return null;
    }
    let profile = null;
    if (loginData !== null) {
      profile = loginData.items.profile;
    }
    return profile;
  }
}
